/* eslint-disable linebreak-style */
/* eslint-disable no-confusing-arrow */
/* eslint-disable import/no-cycle */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable spaced-comment */

import { useForm, } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import SIEStore from "../../../assets/images/SIE-store.png";
import { Button, Col, Dropdown, Row, Separator, Text, Textarea, Title, Loader } from "../../../components/ui";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { userSelector, myProfileSelector } from "../../auth/auth.selectors";

import { isSubmittingPublicSelector } from "../../public/public.selectors";
import styles from "./ContactAndForms.module.scss";
import { submitForm } from "./service/contactAndForms.actions";
import { IContactData } from "./service/contactAndForms.types";
// import trackHistory from "../../../common/helpers/trackHistory";
import { appInsightsService } from "../../../services/appInsights/appInsights";
import trackClickHandler from "../../../common/helpers/trackClickHandler";
import { fetchMyProfileData } from "../../auth/auth.actions";
import { toastError } from "../../../services";
import { INTERNET_COAXAL, INTERNET_OPTIQ, INTERNET_STATUS } from "../../multimedia/myMultimediaOffer/service/myMultimediaOffer.constants";
import { fetchMyMultimediaOffer } from "../../multimedia/myMultimediaOffer/service/myMultimediaOffer.actions";
import {
  externalClientSelector,
  isFetchingMyMultimediaOfferSelector,
  myMultimediaOfferSelector,
  otoSelector,
} from "../../multimedia/myMultimediaOffer/service/myMultimediaOffer.selectors";

const contactReason = "Veuillez sélectionner la raison du contact";
const contactReasons = [
  {
    name: "Déménagement",
    comment: null,
    email: null
  },
  {
    name: "Paiements et facturation",
    comment: null,
    email: null
  },
  {
    name: "Tarifs",
    comment: null,
    email: null
  },
  {
    name: "Relevés de compteurs",
    comment: null,
    email: null
  },
  {
    name: "Pannes et dépannages",
    comment: null,
    email: null
  },
  {
    name: "Demande d’informations",
    comment: null,
    email: null
  },
  {
    name: "Multimédia",
    comment: null,
    email: null
  },
  {
    name: "Demande d’activation de raccordement multimédia",
    comment: null,
    email: null
  },
  {
    name: "Demande de désactivation du raccordement multimédia",
    comment: null,
    email: null
  },
  {
    name: "Demande d'activation de la courbe de charge",
    comment: `Merci de bien vouloir activer ma courbe de charge pour visualiser ma consommation.\nCordialement\n`,
    email: "datagestion@sie.ch"
  },
  {
    name: "Autres",
    comment: null,
    email: null
  }
];

const ContactAndForms = () => {
  const location = window.location.href;
  appInsightsService.trackPageView(location);

  const dispatch = useAppDispatch();
  const isFetching = useAppSelector(isFetchingMyMultimediaOfferSelector);
  const { name, lastName, recipient } = useAppSelector(userSelector);
  const myProfile = useAppSelector(myProfileSelector);
  const isSubmitting = useAppSelector(isSubmittingPublicSelector);
  const addresses = useAppSelector(myMultimediaOfferSelector);

  useEffect(() => {
    dispatch(fetchMyMultimediaOffer());
  }, []);

  useEffect(() => {
    dispatch(fetchMyProfileData());
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      reason: contactReason,
      message: "",
      email: "",
      recipient: "",
    },
    shouldUnregister: true,
  });

  const reasonContent = watch('reason');
  const textContent = watch('message');

  const onContactFormSubmit = (
    data: Omit<IContactData, "lastname" | "firstname">
  ) => {
    const apiData = data;
    if (reasonContent === contactReason) {
      apiData.reason = "Autres";
    } else {
      apiData.reason = reasonContent;
    }
    dispatch(
      submitForm({ ...apiData, email: myProfile?.contact?.email ?? "", firstname: name, lastname: lastName }, reset)
    );
  };

  const onContactFormError = () => {
    toastError({
      message:
        "Le formulaire est vide. Veuillez remplir tous les champs requis avant de soumettre le formulaire.",
    });
  };

  const onChangeReason = (event) => {
    setValue('reason', event.target.value);
    if (event.target.value === contactReasons[9].name) {
      setValue('message', contactReasons[9].comment ?? '');
      setValue('recipient', contactReasons[9].email ?? '');
    } else {
      setValue('message', '');
      setValue('recipient', '');
    }
    document.getElementById("messageId")?.focus();
  };

  useEffect(
    () => {
      // trackHistory(sessionStorage.getItem("clicks") ?? 0, location);
      sessionStorage.removeItem("clicks");
    },
    []
  );

  if (!myProfile || isFetching) {
    return <Loader type="page" />;
  }

  return (
    <Row align="start" direction="column" justify="start">
      <section className={styles.contactWrapper}>
        <Title>Contactez-nous</Title>
        <Row
          wrapForMobile
          align="start"
          className={styles.contactHeadSectionContent}
        >
          <Col lg={4} md={6} span={12}>
            <article className={styles.contactAddress}>
              <Title isBoxTitle level={3}>
                Votre Espace Conseils
              </Title>
              <div className={styles.contactImageWrapper}>
                <img alt="img" className={styles.contactStore} src={SIEStore} />
              </div>
              <Text align="center">
                Rue Neuve 5<br />
                1020 Renens
              </Text>
              <div className={styles.contactSeparator} />
              <Text align="center">
                Horaires d’ouverture :<br />
                Du lundi au vendredi : 9h – 18h
                <br />
                Samedi : 9h - 13h30
                <br />
              </Text>
            </article>
          </Col>
          <Col lg={8} md={6} span={12}>
            <article className={styles.contactWorkHours}>
              <Title level={3}>Nos coordonnées</Title>
              <Text>
                Email : info@sie.ch
                <br />
                Téléphone : 021 631 50 00
                <br />
                Du lundi au vendredi : 8h – 12h / 13h – 17h
                <br />
                Courrier : SIE SA Espace Conseils, rue Neuve 5, case postale,
                1020 Renens
              </Text>
              {(addresses.filter(x => x.internetOptiq === INTERNET_OPTIQ.TVT_PRO).length > 0) && (
                <>
                  <Title level={3}>Nous contacter pour les services TVT PRO :</Title>
                  <Text>
                    Email : pro@tvtservices.ch
                    <br />
                    Téléphone : 021 631 50 02
                    <br />
                    Du lundi au vendredi : 8h – 12h / 13h – 17h
                  </Text>
                </>
              )}
              <div className={styles.contactSeparator} />
              <Title level={3}>En dehors des heures ouvrables</Title>
              <Text>
                La surveillance du réseau électrique de SIE SA est assurée par
                le centre de conduite des réseaux de Romande Energie.
                <br />
                En dehors des heures ouvrables, en cas de panne de réseau et
                pour toutes urgences énergie uniquement, les équipes
                d’intervention sont atteignables, 24h sur 24, au 0848 802 555.
                <br />
              </Text>
              <Title level={3}>
                Vous êtes un grand consommateur (100&apos;000 kWh/an)
              </Title>
              <Text>Email : ventes@sie.ch</Text>
            </article>
          </Col>
        </Row>
        <Separator size="large" />
      </section>
      <section className={styles.contactFormWrapper}>
        <Title level={2}>Formulaire de contact</Title>
        <Text>
          Pour toutes questions ou demandes, vous pouvez aussi nous envoyer un
          message via le formulaire ci-dessous, nous vous répondrons dans les
          plus brefs délais.
        </Text>
        <Text>
          Merci de sélectionner l’objet de votre demande dans « Raison du
          contact ».
        </Text>
        <Separator size="xlarge" />
        <form onSubmit={handleSubmit(onContactFormSubmit, onContactFormError)}>
          <Dropdown
            {...register("reason", {
              required: true,
            })}
            id="reason"
            name="reason"
            options={contactReasons.map(reason => reason.name)}
            placeholder={contactReason}
            value={reasonContent}
            onChange={onChangeReason}
          />
          <Separator size="xlarge" />
          <Textarea
            {...register("message", {
              required: true,
              maxLength: 10000,
            })}
            error={!!errors.message}
            id="messageId"
            label="Votre message"
            name="message"
            rows={15}
            value={textContent}
            onChange={(event) => {
              setValue('message', event.target.value);
              trackClickHandler();
            }}
          />
          <Separator size="xlarge" />
          <div className={styles.contactButtonsWrapper}>
            <Button
              buttonStyle="secondaryButton"
              type="button"
              onClick={() => {
                reset({ reason: contactReason, message: "" });
                trackClickHandler();
              }}
            >
              Annuler
            </Button>
            <Button
              loading={isSubmitting}
              type="submit"
              onClick={trackClickHandler}
            >
              Valider
            </Button>
          </div>
        </form>
      </section>
    </Row>
  );
};

export default ContactAndForms;
